import { BaseModel } from "sjs-base-model";

export default class SalesByProductStatDataItemModel extends BaseModel {
    date = "";
    productType = "";
    paymentMethod = "";
    totalSale = 0;
    minSale = 0;
    maxSale = 0;
    avgSale = 0;
    totalDays = 0;
    avgDays = 0;
    minDays = 0;
    maxDays = 0;

    constructor(data) {
        super();
        this.update(data);
    }
}
